export const FUNNEL_STAGES = [
  "New Lead",
  "Initial Contact",
  "Follow-up Call",
  "Email/Text",
  "Test Drive Booked",
  "Test Drive Done",
  "Quote/Negotiation",
  "Finance/Approval",
  "Closed-Won",
  "Closed-Lost",
];

export const stageStyle = {
  "New Lead": "bg-blue-500/12 text-blue-400",
  "Initial Contact": "bg-indigo-500/12 text-indigo-400",
  "Follow-up Call": "bg-sky-500/12 text-sky-400",
  "Email/Text": "bg-cyan-500/12 text-cyan-400",
  "Test Drive Booked": "bg-violet-500/12 text-violet-400",
  "Test Drive Done": "bg-purple-500/12 text-purple-400",
  "Quote/Negotiation": "bg-amber-500/12 text-amber-400",
  "Finance/Approval": "bg-orange-500/12 text-orange-400",
  "Closed-Won": "bg-green-500/12 text-green-400",
  "Closed-Lost": "bg-rose-500/12 text-rose-400",
};

export const tomorrowISO = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
};

export const fmtDate = (s) => {
  if (!s) return "";
  try {
    return new Date(s).toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return s;
  }
};

export const fmtDateTime = (s) => {
  if (!s) return "";
  try {
    return new Date(s).toLocaleString("en-CA", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return s;
  }
};
